import { useRequestGetUsers } from '@/hooks/httpRequest';
import useUrlParams from './useUrlParams';
import { useScreenSize } from '@/hooks';

const useUsers = () => {
  const { status } = useScreenSize();
  const { sortType, sortBy, limit, page, gender, certified, searchQuery, accountStatus, transactionId } = useUrlParams();

  const params = {
    // Base parameters always present
    limit,
    gender,
    page,

    // Conditional parameters based on context
    ...(transactionId ? { transactionId } : {
      emailOrUsername: searchQuery,
      accountStatus,
      certified,
      sortType,
      sortBy
    })
  };

  const result = useRequestGetUsers(
    params as any,
    status != 'isLoading'
    // Use default endpoint (routes.api.searchUser)
  );

  return result;
};

export default useUsers;
